module.exports = __webpack_public_path__ + "img/pdf.50b88751.png";